module.exports = __webpack_public_path__ + "img/compact_disc_half_grey.edb0e690.svg";